import { InvoiceDiscountMode } from '../enums/invoiceDiscountMode'

export type DiscountModeTrackingValue = 'none' | 'line' | 'global'

const discountModeTrackingValueMap: Record<InvoiceDiscountMode, DiscountModeTrackingValue> = {
  [InvoiceDiscountMode.None]: 'none',
  [InvoiceDiscountMode.ByItem]: 'line',
  [InvoiceDiscountMode.Global]: 'global',
}

export const getDiscountModeTrackingValue = (discountMode: InvoiceDiscountMode): DiscountModeTrackingValue =>
  discountModeTrackingValueMap[discountMode]
